'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.wixDataError = wixDataError;
exports.validationError = validationError;
exports.isDataHookError = isDataHookError;
exports.dataHookError = dataHookError;
exports.schemaNotFoundError = schemaNotFoundError;
exports.BulkError = BulkError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _sharedTypeUtils = require('./shared/type-utils');

var _wixCloudBaseErrorsDefinitions = require('@wix/cloud-base-errors-definitions');

var _safeJsonStringify = require('safe-json-stringify');

var _safeJsonStringify2 = _interopRequireDefault(_safeJsonStringify);

// When adding new messages, update Support article with error code and explanation about the error.
var messages = {
  collectionNameMustBeAString: function collectionNameMustBeAString() {
    return 'WDE0001: Collection name must be a string.';
  },
  itemIdMustBeAString: function itemIdMustBeAString() {
    return 'WDE0002: ItemId must be a string.';
  },
  itemIdsMustBeArrayOfStrings: function itemIdsMustBeArrayOfStrings() {
    return 'WDE0068: Item ids must be an array of strings';
  },
  removeItemsMustBeLessThanThousand: function removeItemsMustBeLessThanThousand(collectionName) {
    return 'WDE0069: Failed to remove items from [' + collectionName + '].\nCannot remove more than 1000 items in one request';
  },
  fieldNameMustBeAString: function fieldNameMustBeAString() {
    return 'WDE0003: FieldName must be a string.';
  },
  itemMustBeAnObject: function itemMustBeAnObject(item, collectionName) {
    return 'WDE0004: Failed to save [' + item + '] into [' + collectionName + '].\nItems must be JavaScript objects.';
  },
  itemsMustBeArrayOfObjects: function itemsMustBeArrayOfObjects(collectionName) {
    return 'WDE0005: Failed to bulk save items into [' + collectionName + '].\nItems must be an array of JavaScript objects and itemIds must be strings if present.';
  },
  itemsMustBeLessThanThousand: function itemsMustBeLessThanThousand(collectionName) {
    return 'WDE0006: Failed to bulk save items into [' + collectionName + '].\nCannot insert more than 1000 items in one request';
  },
  updateItemInvalid: function updateItemInvalid() {
    return 'WDE0007: Invalid update. Updated object must have a string _id property.';
  },
  invalidArgumentLength: function invalidArgumentLength(method, from, to, actual) {
    return 'WDE0008: wixData.' + method + ' expects between ' + from + ' and ' + to + ' arguments, but was called with ' + actual + '.';
  },
  documentTooLarge: function documentTooLarge() {
    return 'WDE0009: Document is too large.';
  },
  aggregateValidations: {
    aggregateInvalid: function aggregateInvalid(collectionName, invalidArguments) {
      return 'Failed to perform aggregation on [' + collectionName + '].\n' + invalidArguments.join('\n');
    },
    filterMustBeBuilder: function filterMustBeBuilder(operatorName) {
      return 'WDE0011: Invalid ' + operatorName + ' usage. ' + operatorName + ' requires WixDataFilter.';
    },
    filterIsAlreadySet: function filterIsAlreadySet(operatorName) {
      return 'WDE0012: Invalid ' + operatorName + ' usage. Filter is already set.';
    },
    groupIsAlreadySet: function groupIsAlreadySet(operatorName) {
      return 'WDE0013: Invalid ' + operatorName + ' usage. Group is already set.';
    }
  },
  filterBuilderInvalid: function filterBuilderInvalid(invalidArguments) {
    return 'Failed to build a filter.\n' + invalidArguments.join('\n') + '.';
  },
  groupBuilderInvalid: function groupBuilderInvalid(invalidArguments) {
    return 'Failed to build group.\n' + invalidArguments.join('\n') + '.';
  },
  filterMustBeAnObject: function filterMustBeAnObject() {
    return 'WDE0016: Filter must be an object.';
  },
  sortBuilderInvalid: function sortBuilderInvalid(invalidArguments) {
    return 'Failed to build a sort.\n' + invalidArguments.join('\n') + '.';
  },
  optionsInvalid: function optionsInvalid(properties) {
    return 'WDE0018: Options must be an object with one or all of the following boolean properties: ' + properties.join(', ') + '.';
  },
  referenceOperationParameterError: function referenceOperationParameterError() {
    return 'WDE0019: Reference operation takes a string ID or an object with an ID to be connected.';
  },
  referenceOperationFieldError: function referenceOperationFieldError(fieldName) {
    return 'WDE0020: Provided relationshipAttribute [' + fieldName + '] is not a multi-reference field.';
  },
  invalidReferenceError: function invalidReferenceError() {
    return 'WDE0021: Invalid reference';
  },
  multipleMultiRefIncludeError: function multipleMultiRefIncludeError() {
    return 'WDE0022: Unable to execute a query. Only single multi-reference field can be included.';
  },
  multiRefItemLimitError: function multiRefItemLimitError() {
    return 'WDE0023: Can not fetch more than 50 elements when include is being used on multi-reference field';
  },
  fieldIsDeleted: function fieldIsDeleted() {
    return 'WDE0024: Field is deleted';
  },
  schemaDoesNotExist: function schemaDoesNotExist(collectionName) {
    return 'WDE0025: The ' + collectionName + ' collection does not exist. You cannot work with a collection using the Data API before it is created in the Editor.';
  },
  collectionDeleted: function collectionDeleted(collectionName) {
    return 'WDE0026: The ' + collectionName + ' collection was removed, so you cannot work with it. To restore its data, create a new collection with the same name.';
  },
  permissionDenied: function permissionDenied(action, collectionName) {
    return 'WDE0027: The current user does not have permissions to ' + action + ' on the ' + collectionName + ' collection.';
  },
  requestTimedOut: function requestTimedOut() {
    return 'WDE0028: Request timed out.';
  },
  internalAuthorizationProblem: function internalAuthorizationProblem() {
    return 'WDE0029: An internal error has occurred while trying to check authorization.';
  },

  queryValidations: {
    queryInvalid: function queryInvalid(collectionName, invalidArguments) {
      return 'Failed to perform query on [' + collectionName + '].\n' + invalidArguments.join('\n');
    },
    collectionNameIsRequired: function collectionNameIsRequired() {
      return 'WDE0031: Collection name is required and must be a string.';
    },
    isNumber: function isNumber(operatorName, specifier, operand) {
      return 'WDE0032: Invalid ' + operatorName + ' parameter [' + (0, _sharedTypeUtils.typeForDisplay)(operand) + ']. ' + operatorName + ' parameter must be a ' + specifier + ' number.';
    },
    isPositiveNumber: function isPositiveNumber(operatorName, operand) {
      return 'WDE0033: Invalid ' + operatorName + ' parameter [' + operand + ']. ' + operatorName + ' parameter must be a positive number.';
    },
    isNonNegativeNumber: function isNonNegativeNumber(operatorName, operand) {
      return 'WDE0034: Invalid ' + operatorName + ' parameter [' + operand + ']. ' + operatorName + ' parameter must be a non-negative number.';
    },
    isInteger: function isInteger(operatorName, operand) {
      return 'WDE0035: Invalid ' + operatorName + ' parameter [' + operand + ']. ' + operatorName + ' parameter must be an integer.';
    },
    notGreaterThan: function notGreaterThan(operatorName, operand, value) {
      return 'WDE0036: Invalid ' + operatorName + ' parameter [' + operand + ']. ' + operatorName + ' parameter cannot exceed ' + value + '.';
    },
    invalidSkipParameter: function invalidSkipParameter(collectionName, skipParameter) {
      return 'WDE0037: Invalid query on [' + collectionName + '].\nInvalid prev positioned query skip on a negative number ' + skipParameter + '.';
    }
  },
  arityValidations: {
    arityIsZero: function arityIsZero(operatorName) {
      return 'WDE0038: Invalid ' + operatorName + ' usage. ' + operatorName + ' does not take parameters.';
    },
    arityIsOne: function arityIsOne(operatorName) {
      return 'WDE0039: Invalid ' + operatorName + ' usage. ' + operatorName + ' requires one parameter.';
    },
    arityIsTwo: function arityIsTwo(operatorName) {
      return 'WDE0040: Invalid ' + operatorName + ' usage. ' + operatorName + ' requires two parameters.';
    },
    arityIsThree: function arityIsThree(operatorName) {
      return 'WDE0041: Invalid ' + operatorName + ' usage. ' + operatorName + ' requires three parameters.';
    },
    arityIsAtLeastTwo: function arityIsAtLeastTwo(operatorName) {
      return 'WDE0042: Invalid ' + operatorName + ' usage. ' + operatorName + ' requires at least two parameters.';
    },
    arityIsAtLeastOne: function arityIsAtLeastOne(operatorName) {
      return 'WDE0043: Invalid ' + operatorName + ' usage. ' + operatorName + ' requires at least one parameter.';
    }
  },
  filterValidations: {
    typeIsString: function typeIsString(operatorName, value) {
      return 'WDE0044: Invalid ' + operatorName + ' parameter value [' + (0, _sharedTypeUtils.typeForDisplay)(value) + ']. ' + operatorName + ' parameter must be a String.';
    },
    typeIsStringNumberOrDate: function typeIsStringNumberOrDate(operatorName, value) {
      return 'WDE0045: Invalid ' + operatorName + ' parameter value [' + (0, _sharedTypeUtils.typeForDisplay)(value) + ']. Valid ' + operatorName + ' parameter types are String, Number or Date.';
    },
    sameType: function sameType(operatorName, first, second) {
      return 'WDE0046: Invalid ' + operatorName + ' parameter values [' + (0, _sharedTypeUtils.typeForDisplay)(first) + '] and [' + (0, _sharedTypeUtils.typeForDisplay)(second) + ']. Both parameters must be of the same type.';
    },
    typeIsStringNumberOrDateForAll: function typeIsStringNumberOrDateForAll(operatorName) {
      return 'WDE0047: Invalid ' + operatorName + ' usage. ' + operatorName + ' supports only Number, String or Date items.';
    },
    validFieldName: function validFieldName(operatorName, field) {
      return 'WDE0048: Invalid ' + operatorName + ' field value [' + (0, _sharedTypeUtils.typeForDisplay)(field) + ']. ' + operatorName + ' field must be a String.';
    },
    isInstanceOfSameClass: function isInstanceOfSameClass(operatorName, constructorName, obj) {
      return 'WDE0049: Invalid ' + operatorName + ' parameter [' + (0, _sharedTypeUtils.typeForDisplay)(obj) + ']. ' + operatorName + ' expects ' + constructorName + ' only.';
    },
    isForCollection: function isForCollection(operatorName, constructorName, collectionName) {
      return 'WDE0050: Invalid ' + operatorName + ' parameter query for [' + collectionName + ']. ' + operatorName + ' accepts ' + constructorName + ' for the same collection only.';
    }
  },
  filterTreeValidations: {
    objectType: function objectType(operatorName) {
      return 'WDE0056: ' + operatorName + ' should be an Object. Got ${0} instead';
    },
    arrayType: function arrayType(operatorName) {
      return 'WDE0057: ' + operatorName + ' should be an Array. Got ${0} instead';
    },
    arrayLength: function arrayLength(operatorName, expectedLength) {
      return 'WDE0057: ${0}.length is ${0/length}. ' + operatorName + ' Array should have length ' + expectedLength;
    },
    comparisonOperatorType: function comparisonOperatorType(operatorName) {
      return 'WDE0058: ' + operatorName + ' should be a Date, Number, or String. Got ${0} instead';
    },
    stringOperatorType: function stringOperatorType(operatorName) {
      return 'WDE0059: ' + operatorName + ' should be a String. Got ${0} instead';
    },
    setOperatorItems: function setOperatorItems(operatorName) {
      return 'WDE0060: ' + operatorName + ' Array should only contain values of types Date, Number, and String. Got ${0} instead';
    },
    inOperatorItems: function inOperatorItems() {
      return 'WDE0061: $in Array should have length 2, and match [String, Number]. Got ${0} instead';
    },
    matchesOperatorRequiredProperty: function matchesOperatorRequiredProperty(propertyName) {
      return 'WDE0062: $matches value ${0} does not have property ' + propertyName;
    },
    matchesOperatorIgnoreCase: function matchesOperatorIgnoreCase() {
      return 'WDE0063: $matches.ignoreCase should equal true. Got ${0/ignoreCase} instead';
    },
    matchesOperatorSpecItems: function matchesOperatorSpecItems() {
      return 'WDE0064: $matches.spec Array values should be either {"type":"anyOf","value":" -"} or {"type":"literal","value":String}. Got ${0} instead';
    }
  },
  sortValidations: {
    typeIsStringOrArrayOfStrings: function typeIsStringOrArrayOfStrings(operatorName, effectiveArgs) {
      return 'WDE0051: Invalid ' + operatorName + ' parameters [' + effectiveArgs.map(_sharedTypeUtils.typeForDisplay) + ']. Valid ' + operatorName + ' values are String, Array of String or varargs String.';
    }
  },
  orderByValidations: {
    sortModelType: function sortModelType() {
      return 'WDE0065: Sort Model should be an Array. Got ${0} instead';
    },
    sortModelItemType: function sortModelItemType() {
      return 'WDE0066: Sort Model Array should contain values of type Object only. Got ${0} instead';
    },
    sortModelItem: function sortModelItem() {
      return 'WDE0067: Sort Model Array items should have a single property with value "asc" or "desc". Got ${0} instead';
    }
  },
  siteIsInTemplateMode: function siteIsInTemplateMode() {
    return 'WDE0052: The current site is in template mode. Please save it to modify data.';
  },
  internalError: function internalError(message) {
    return 'WDE0053: Internal wixData error: ' + message;
  },
  serverGeneralError: function serverGeneralError() {
    return 'WDE0054: The server could not fulfill the request.';
  },
  serverInvalidResponse: function serverInvalidResponse() {
    return 'WDE0055: Failed to parse server response.';
  },
  tooManyRequests: function tooManyRequests() {
    return 'WDE0014: Too many requests.';
  },
  operationNotSupported: function operationNotSupported(collectionName, operation) {
    return collectionName + ' does not support ' + operation + ' operation.';
  }
};

exports.messages = messages;
var codes = {
  ItemDoesNotExist: 'WD_ITEM_DOES_NOT_EXIST',
  ItemAlreadyExists: 'WD_ITEM_ALREADY_EXISTS',
  SiteInTemplateMode: 'WD_SITE_IN_TEMPLATE_MODE',
  UnknownError: 'WD_UNKNOWN_ERROR',
  ValidationError: 'WD_VALIDATION_ERROR',
  CollectionDeleted: 'WD_COLLECTION_DELETED',
  SchemaDoesNotExist: 'WD_SCHEMA_DOES_NOT_EXIST',
  PermissionDenied: 'WD_PERMISSION_DENIED',
  BadRequest: 'WD_BAD_REQUEST',
  Unauthorized: 'WD_UNAUTHORIZED',
  TooManyRequests: 'WD_TOO_MANY_REQUESTS',
  RequestTimedOut: 'WD_REQUEST_TIMED_OUT'
};

exports.codes = codes;
// todo add code

function wixDataError(message, code) {
  return errorWithCode(message, code);
}

function validationError(message) {
  return errorWithCode(message, codes.ValidationError);
}

var DATA_HOOK_ERROR_NAME = 'WixDataHookError';

exports.DATA_HOOK_ERROR_NAME = DATA_HOOK_ERROR_NAME;

function isDataHookError(err) {
  return err instanceof Error && err.name === DATA_HOOK_ERROR_NAME;
}

function dataHookError(err) {
  function buildObj(err) {
    if (err === undefined) {
      return { type: 'undefined' };
    } else if (err instanceof Error) {
      return { type: 'error', value: err.message };
    } else {
      return { type: 'value', value: err };
    }
  }

  function stringify(obj) {
    return (0, _safeJsonStringify2['default'])(obj);
  }

  var errorInstance = new Error(stringify(buildObj(err)));
  errorInstance.name = DATA_HOOK_ERROR_NAME;
  errorInstance.originalError = err;

  Error.captureStackTrace(errorInstance, dataHookError);
  return errorInstance;
}

function errorWithCode(message, code) {
  var ErrorConstructor = code && code !== codes.UnknownError ? WixDataError : Error;
  var error = new ErrorConstructor(message);
  error.code = code;
  return error;
}

function schemaNotFoundError(collectionName) {
  return wixDataError(messages.schemaDoesNotExist(collectionName), codes.SchemaDoesNotExist);
}

function BulkError(message, code, item) {
  var errorInstance = new Error(message);
  errorInstance.code = code;
  errorInstance.item = item;
  Object.setPrototypeOf(errorInstance, Object.getPrototypeOf(this));
  Error.captureStackTrace(errorInstance, BulkError);
  return errorInstance;
}

BulkError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});

function WixDataError(message) {
  var errorInstance = new _wixCloudBaseErrorsDefinitions.UserCodeError(message);
  Object.setPrototypeOf(errorInstance, Object.getPrototypeOf(this));
  Error.captureStackTrace(errorInstance, WixDataError);
  errorInstance.name = Error.name;
  return errorInstance;
}

WixDataError.prototype = Object.create(_wixCloudBaseErrorsDefinitions.UserCodeError.prototype, {
  constructor: {
    value: WixDataError,
    enumerable: false,
    writable: true,
    configurable: true
  }
});